import React from "react";
import { FiHome, FiUserCheck, FiTrendingUp, FiCheckSquare } from "react-icons/fi";

export const NAV_ITEMS = [
  { name: "Dashboard", path: "/dashboard", icon: <FiHome /> },
  { name: "Outreach", path: "/outreach", icon: <FiTrendingUp /> },
  { name: "To-Do", path: "/todo", icon: <FiCheckSquare /> },
  { name: "Partners", path: "/partners", icon: <FiUserCheck /> },
];

// Filter nav items based on user type
export const getNavItemsForUser = (currentUser) => {
  // If partner user, only show Dashboard
  if (currentUser?.isPartner) {
    return NAV_ITEMS.filter(item => 
      item.path === "/dashboard"
    );
  }
  
  // For regular users, show all items except Partners (which is only for non-partner users)
  return NAV_ITEMS;
};


